import React from 'react';
import { X } from 'lucide-react';
export function SalesContent() {
  return <>
      {/* BLOCK 2 — LEAD / HOOK DE APERTURA */}
      <section className="py-12 md:py-14 px-4 md:px-6 bg-[#faf6f1] text-[#3d2b1f] relative" data-id="element-197">
        <div className="max-w-3xl mx-auto animate-hero-fade-in" data-id="element-198">
          <div className="prose prose-lg mx-auto text-[#6b5744] text-lg md:text-xl leading-relaxed" data-id="element-199">
            <p className="font-bold text-2xl md:text-3xl text-[#3d2b1f] mb-6" data-id="element-200">
              Hay algo que nadie te dijo cuando llegaste a este país.
            </p>
            <p className="mb-4" data-id="element-201">Te dijeron que trabajaras duro.</p>
            <p className="mb-4" data-id="element-202">Te dijeron que aprendieras inglés.</p>
            <p className="mb-6" data-id="element-203">Te dijeron que fueras paciente.</p>
            <p className="mb-6" data-id="element-204">
              Y tú hiciste todo eso. Te levantaste antes que el sol. Aguantaste
              el frío en el estacionamiento. Sonreíste aunque estuvieras
              agotada. Diste el 100% en un trabajo que te pagaba el mínimo.
            </p>
            <p className="mb-6" data-id="element-205">
              Y aun así, al final del mes, los números no alcanzaban.
            </p>
            <p className="mb-6" data-id="element-206">
              No porque seas menos. No porque no trabajes suficiente. Sino
              porque nadie te enseñó que existe un mercado completamente
              diferente.
            </p>
            <p className="mb-6" data-id="element-207">
              Uno que no te pide que llegues a las 6am. Que no te hace manejar
              40 minutos bajo la nieve. Que no te deja con las manos secas y la
              espalda doblada.
            </p>
            <p className="mb-6 font-bold text-[#3d2b1f]" data-id="element-208">
              Un mercado que paga por lo que ya tienes. Tu español.
            </p>
            <p className="mb-6" data-id="element-209">
              Mientras tú vendías tu espalda por $12 la hora, hay mujeres
              latinas como tú — sin título universitario, sin inglés fluido, sin
              experiencia previa — ganando $200, $300, hasta $500 a la semana
              desde su teléfono.
            </p>
            <p className="mb-4" data-id="element-210">No porque tengan más suerte.</p>
            <p className="mb-6 text-2xl text-[#c9977e] font-serif italic" data-id="element-211">
              Sino porque alguien les mostró el mapa.
            </p>
            <p className="font-bold text-2xl text-[#b8956a]" data-id="element-212">
              Este es ese mapa.
            </p>
          </div>
        </div>
      </section>

      {/* BLOCK 4 — FRACASO DE LAS SOLUCIONES EXISTENTES */}
      <section className="py-14 md:py-16 px-4 md:px-6 bg-[#faf6f1]" data-id="element-213">
        <div className="max-w-4xl mx-auto animate-hero-fade-in" data-id="element-214">
          <div className="text-center mb-10" data-id="element-215">
            <h2 className="text-3xl md:text-4xl font-bold text-[#3d2b1f] mb-3" data-id="element-216">
              Por qué los cursos de "trabaja desde casa" que viste antes no te
              funcionaron.
            </h2>
            <p className="text-lg text-[#c47a6a] font-medium" data-id="element-217">
              (No fue tu culpa. El sistema estaba diseñado para fallar.)
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8" data-id="element-218">
            {[{
            title: 'Necesitas hablar inglés fluido',
            desc: 'Y cerraste el módulo 1'
          }, {
            title: 'Necesitas una computadora potente',
            desc: "Y pensaste 'no tengo para eso'"
          }, {
            title: 'Necesitas años de experiencia en marketing',
            desc: 'Y te sentiste pequeña'
          }, {
            title: 'Necesitas construir una audiencia primero',
            desc: 'Y calculaste que eso tomaría años'
          }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white p-5 rounded-2xl shadow-sm border border-[#e0bfb4]/30" data-id="element-219">
                <div className="bg-[#c47a6a]/10 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-220">
                  <X className="w-5 h-5 text-[#c47a6a]" data-id="element-221" />
                </div>
                <div data-id="element-222">
                  <h3 className="font-bold text-[#3d2b1f] mb-1" data-id="element-223">
                    {item.title}
                  </h3>
                  <p className="text-[#6b5744] text-sm leading-relaxed" data-id="element-224">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="text-center max-w-2xl mx-auto" data-id="element-225">
            <p className="text-xl text-[#3d2b1f] font-bold mb-4" data-id="element-226">
              Esos cursos no fallaron porque tú no eras suficiente. Fallaron
              porque fueron diseñados para un perfil diferente al tuyo.
            </p>
            <p className="text-lg text-[#6b5744] mb-2" data-id="element-227">
              Freelance Desde Cero fue construido para ti. Para la que tiene
              solo su teléfono y su español.
            </p>
            <p className="text-xl font-bold text-[#b8956a]" data-id="element-228">
              Para la que necesita resultados esta semana, no en seis meses.
            </p>
          </div>
        </div>
      </section>
    </>;
}